/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// COMPONENTS
import MUIDataTable from 'mui-datatables';
// ICONS
// CUSTOM COMPONENTS
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import ModalBlock from '../../../../components/ModalBlock';
import FormBlock from '../../../../components/FormBlock';
import Button from '../../../../components/Button';
import InputBlock from '../../../../components/InputBlock';
import OverLay from '../../../../components/Overlay';
import CheckboxBlock from '../../../../components/CheckboxBlock';
// REDUX
import * as alert from '../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as helper from '../../../../helpers/helper';
import * as quoteService from '../../../../services/management/quoteService';

const QuoteListingPage = (props) => {
  const { showAlert, showConfirmModal, hideConfirmModal, auth } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [quotes, setquotes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const initialQuoteModel = {
    id: 0,
    name: '',
    isActive: true
  };
  const [quote, setQuote] = useState(initialQuoteModel);

  useEffect(() => {
    getQuotes();
  }, []);

  const formik = useFormik({
    initialValues: quote,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      name: Yup.string().required().max(500),
      isActive: Yup.bool().nullable(),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      if (values.id === 0) {
        createQuote(values);
      } else {
        updateQuote(values);
      }
    },
  });

  const getQuotes = () => {
    setIsLoading(true);
    quoteService.getQuotes('').then((res) => {
      setquotes(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const deleteQuote = (id) => {
    setIsLoading(true);
    hideConfirmModal();
    quoteService.deleteQuote(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getQuotes();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createQuote = (model) => {
    quoteService.createQuote(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getQuotes();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleModalClose();
      setIsLoading(false);
    });
  };

  const updateQuote = (model) => {
    quoteService.updateQuote(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getQuotes();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleModalClose();
      setIsLoading(false);
    });
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setQuote(initialQuoteModel);
      formik.resetForm();
    }, 250);
  };

  // const iconSize = 22;
  // const iconColor = 'white--clr';

  const columnOptions = {
    filter: true,
    sort: true,
    print: false,
    download: true
  };

  const options = {
    selectableRows: 'none',
    download: true,
    print: false,
  };

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        print: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const { id } = quotes[dataIndex];

          return (
            <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
              <Button
                text="View"
                className="primary--bg ml-0"
                size="xxs"
                to={`/quote/${id}`}
              />

              {
                auth.accessLevel >= 50 && (
                  <Button
                    text="Delete"
                    className="danger--bg"
                    size="xxs"
                    onClick={() => {
                      showConfirmModal({
                        title: 'Delete Quote',
                        text: 'Are you sure you want to delete this quote?',
                        rightBtnText: 'Confirm',
                        btnAction: () => {
                          deleteQuote(id);
                        }
                      });
                    }}
                  />
                )
              }
            </CustomBlock>
          );
        }
      }
    },
    {
      name: 'quoteNo',
      label: 'Quote No',
      options: columnOptions,
    },
    {
      name: 'client',
      label: 'Client',
      options: columnOptions,
    },
    {
      name: 'status',
      label: 'Status',
      options: columnOptions,
    },
    {
      name: 'createdBy',
      label: 'Created By',
      options: columnOptions,
    },
    {
      name: 'createdDateTime',
      label: 'Created On',
      options: columnOptions,
    },
  ];

  return (
    <>
      {isLoading && <OverLay hasLoader />}
      <CustomBlock className="content-container--padded">
        <Section isFullWidth>
          <ContentBlock>
            <CustomBlock className="content-container--card-style--with-shadow">
              <ContentHeader
                title="Quotes"
                headerSize="lg"
                primaryButtonText="New Quote"
                primaryButtonTo="/quote"
              />

              <CustomBlock>
                <MUIDataTable
                  data={quotes}
                  columns={columns}
                  options={options}
                />
              </CustomBlock>
            </CustomBlock>
          </ContentBlock>
        </Section>
      </CustomBlock>

      <ModalBlock
        hasCloseAction
        centered
        isVisible={isModalOpen}
        size="md"
        contentHeader={quote.id === 0 ? 'Add Quote' : 'Edit Quote'}
        primaryModalActionText={quote.id === 0 ? 'Create' : 'Save Changes'}
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={formik.handleSubmit}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={handleModalClose}
      >
        <FormBlock onSubmit={formik.handleSubmit}>
          <Section hasNoContainer>
            <ContentBlock>
              <InputBlock
                label="Name"
                isRequired
                errorMessage={formik.errors.name}
                inputState={`${helper.getInputClasses(formik, 'name')}`}
                {...formik.getFieldProps('name')}
              />
            </ContentBlock>

            <ContentBlock>
              <CheckboxBlock
                label="Is active?"
                id="isActive"
                {...formik.getFieldProps('isActive')}
                isChecked={formik.values.isActive}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(
  mapStateFromProps,
  {
    ...alert.actions,
    ...confirmModal.actions
  }
)(QuoteListingPage);